import React from 'react';

import CBMediaQuery from '../../shared/CBMediaQuery';

import { formatDate, getStyle } from '../../../utils/utils';

class GarageListItem extends React.Component {
  render() {
    const {
      garage, onEditClick
    } = this.props;

    return (
      <CBMediaQuery>
        {screenSize => (
          <tr>
            {
              screenSize === 'large' && (
                <td style={getStyle(screenSize, styles, 'tableValueText')}>{garage.id}</td>
              )
            }
            <td style={getStyle(screenSize, styles, 'tableValueText')}>{garage.profile.first_name}</td>
            <td style={getStyle(screenSize, styles, 'tableValueText')}>{garage.profile.last_name}</td>
            <td style={getStyle(screenSize, styles, 'tableValueText')}>{garage.email}</td>
            {
              screenSize === 'large' && (
                <td style={getStyle(screenSize, styles, 'tableValueText')}>{formatDate(garage.last_login)}</td>
              )
            }
            <td style={getStyle(screenSize, styles, 'tableValueText')}>
              <img
                alt='Options'
                src='/img/icon_edit.svg'
                style={getStyle(screenSize, styles, 'editButton')}
                onClick={() => onEditClick(garage)}
              />
            </td>
          </tr>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    tableValueText: {
      fontFamily: 'TitilliumWeb-Light',
      fontSize: 18,
      color: '#FFFFFF',
    },
    editButton: {
      cursor: 'pointer',
      width: 20,
      height: 20,
    },
  },
};

export default GarageListItem;
